import { Icon } from '~/components/ui/Icon';
import { PLATFORM_NAME } from '~/config';
import { useDocumentTitle } from '~/hooks/useDocumentTitle';

/**
 * Nenhum escritório ativo neste endereço (404 `TENANT_UNKNOWN`). Tela neutra e sem botões: não há
 * o que tentar de novo, e o app não sabe de quem é o endereço para oferecer contato.
 */
export function TenantUnknown(): JSX.Element {
  useDocumentTitle(PLATFORM_NAME);

  return (
    <main className="rx-container rx-screen px-6 py-12 flex flex-col items-center text-center">
      <span
        aria-hidden="true"
        className="flex h-12 w-12 items-center justify-center rounded-full bg-bg-alt mb-5"
      >
        <Icon name="help" size={24} color="var(--rx-text-2)" />
      </span>
      <p className="font-mono text-[11px] uppercase tracking-[0.6px] mb-2 text-ink-muted">
        {PLATFORM_NAME}
      </p>
      <h1 className="text-[22px] font-medium tracking-tight text-ink mb-3">
        Endereço não configurado.
      </h1>
      <p className="text-[14px] text-ink-muted max-w-[34ch]">
        Confirme com o seu escritório o endereço do aplicativo.
      </p>
    </main>
  );
}
